import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';
import useStyles from '../styles/CustomStyle';
import ImageUploader from 'react-images-upload'
import "../styles/MuiCustom.css"
import "../styles/ResponsiveStyle.css"
import { vehicleSeries, riderCategory, years, bikeBrands, cngBrands, carBrands, heroModels, bajajModels, yamahaModels, tvsModels, suzukiModels, runnerModels, keewayModels, toyotaModels, mitsubishiModels, nissanModels, hondaModels, hyundaiModels, mazdaModels, fordModels, cngModels, apriliaModels, znenModels, hundaiModels, motocrossModels, meiduoModels, mahndraModels, pegasusModels, bennettModels, bettleBoltModels, atlasZongshenModels, dayunModels, hpowerModels, haqjueModels, kawasakiModels, ktmModels, kymcoModels, lifanModels, piaggioModels, raceModels, regalraptorsModels, roadmasterModels, symModels, umModels, victorModels, waltonModels, zongshenModels, otherModels, hondaBikeModels, kidenModels } from '../Data/Data'
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { cities } from '../Data/Data'
import NumberFormat from 'react-number-format';


export default function VehiclInformation(props) {
    const classes = useStyles();
    const msg = "This is a required field";
    const handleChange = (e, flag) => {
        if (flag === "registeredOwnerphone" || flag === "license_expiry_date") {
            props.setError({
                ...props.error,
                [flag]: false
            })
        } else if (flag === "license_plate_no") {
            props.setError({
                ...props.error,
                [flag]: {
                    isEmpty: false,
                    invalid: false
                }
            })
        } else if (e.target.name === "car_type") {
            props.setError({
                ...props.error,
                [e.target.name]: false
            })
            props.setModels([]);
            if (e.target.value === 3 || e.target.value === 4) {
                props.setBrands(bikeBrands);
            } else if (e.target.value === 0) {
                // props.setModels( = [];
                props.setBrands(carBrands);
            } else if (e.target.value === 5) {
                // props.setModels( = [];
                props.setBrands(cngBrands);
            } else if (e.target.value === 15) {
                // props.setModels( = [];
                props.setBrands(["Air Ambulance"]);
            } else if (e.target.value === 10) {
                // props.setModels( = [];
                props.setBrands(["CleanCare+ G"]);
            } else if (e.target.value === 9) {
                // props.setModels( = [];
                props.setBrands(["CleanCare+ CNG"]);
            } else if (e.target.value === 11) {
                props.setBrands(["Mobile ICU Ambulance"]);
            } else if (e.target.value === 12) {
                props.setBrands(["AC Ambulance"])
            } else if (e.target.value === 13) {
                props.setBrands(["Non-AC Ambulance"])
            } else if (e.target.value === 14) {
                props.setBrands(["Freezer Ambulance"])
            }
        } else if (e.target.name === "vehicle_make") {
            props.setError({
                ...props.error,
                [e.target.name]: false
            })
            if (e.target.value === "HERO") {
                props.setModels(heroModels);
            } else if (e.target.value === "BAJAJ") {
                props.setModels(bajajModels);
            } else if (e.target.value === "YAMAHA") {
                props.setModels(yamahaModels);
            } else if (e.target.value === "TVS") {
                props.setModels(tvsModels);
            } else if (e.target.value === "SUZUKI") {
                props.setModels(suzukiModels);
            } else if (e.target.value === "RUNNER") {
                props.setModels(runnerModels);
            } else if (e.target.value === "KEEWAY") {
                props.setModels(keewayModels);
            } else if (e.target.value === "Toyota") {
                props.setModels(toyotaModels);
            } else if (e.target.value === "Mitsubishi") {
                props.setModels(mitsubishiModels);
            } else if (e.target.value === "Nissan") {
                props.setModels(nissanModels);
            } else if (e.target.value === "Honda") {
                props.setModels(hondaModels);
            } else if (e.target.value === "Hyundai") {
                props.setModels(hyundaiModels);
            } else if (e.target.value === "Mazda") {
                props.setModels(mazdaModels);
            } else if (e.target.value === "Ford") {
                props.setModels(fordModels);
            } else if (e.target.value === "CNG" || e.target.value === "CleanCare+ CNG") {
                props.setModels(cngModels);
            } else if (e.target.value === "APRILIA") {
                props.setModels(apriliaModels);
            } else if (e.target.value === "ZNEN") {
                props.setModels(znenModels);
            } else if (e.target.value === "HUNDAI") {
                props.setModels(hundaiModels);
            } else if (e.target.value === "MOTOCROSS") {
                props.setModels(motocrossModels);
            } else if (e.target.value === "MEIDUO") {
                props.setModels(meiduoModels);
            } else if (e.target.value === "MAHINDRA") {
                props.setModels(mahndraModels);
            } else if (e.target.value === "PEGASUS") {
                props.setModels(pegasusModels);
            } else if (e.target.value === "BENNETT") {
                props.setModels(bennettModels);
            } else if (e.target.value === "BETTLE BOLT") {
                props.setModels(bettleBoltModels);
            } else if (e.target.value === "ATLAS ZONGSHEN") {
                props.setModels(atlasZongshenModels);
            } else if (e.target.value === "DAYUN") {
                props.setModels(dayunModels);
            } else if (e.target.value === "H POWER") {
                props.setModels(hpowerModels);
            } else if (e.target.value === "HAOJUE") {
                props.setModels(haqjueModels);
            } else if (e.target.value === "KAWASAKI") {
                props.setModels(kawasakiModels);
            } else if (e.target.value === "KIDEN") {
                props.setModels(kidenModels);
            } else if (e.target.value === "KTM") {
                props.setModels(ktmModels);
            } else if (e.target.value === "KYMCO") {
                props.setModels(kymcoModels);
            } else if (e.target.value === "LIFAN") {
                props.setModels(lifanModels);
            } else if (e.target.value === "PIAGGIO") {
                props.setModels(piaggioModels);
            } else if (e.target.value === "RACE") {
                props.setModels(raceModels);
            } else if (e.target.value === "REGAL RAPTOR") {
                props.setModels(regalraptorsModels);
            } else if (e.target.value === "ROADMASTER") {
                props.setModels(roadmasterModels);
            } else if (e.target.value === "SYM") {
                props.setModels(symModels);
            } else if (e.target.value === "UM") {
                props.setModels(umModels);
            } else if (e.target.value === "VICTOR-R") {
                props.setModels(victorModels);
            } else if (e.target.value === "WALTON") {
                props.setModels(waltonModels);
            } else if (e.target.value === "ZONGSHEN") {
                props.setModels(zongshenModels);
            } else if (e.target.value === "OTHER") {
                props.setModels(otherModels);
            } else if (e.target.value === "HONDA") {
                props.setModels(hondaBikeModels);
            } else if (e.target.value === "Air Ambulance" || e.target.value === "Freezer Ambulance" || e.target.value === "Non-AC Ambulance" || e.target.value === "AC Ambulance" || e.target.value === "Mobile ICU Ambulance" || e.target.value === "CleanCare+ G") {
                props.setModels(["Ambulance"]);
            }
        } else {
            props.setError({
                ...props.error,
                [e.target.name]: false
            })
        }
        props.handleChange(e, flag)
    }

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <FormControl className={classes.formControl} required error={props.error.car_type}>
                        <InputLabel id="rider-category">Rider Category</InputLabel>
                        <Select
                            labelId="rider-category-label"
                            id="rider-cat"
                            name="car_type"
                            value={props.stepContent.car_type}
                            onChange={handleChange}
                        >
                            {
                                riderCategory.map(item => (
                                    <MenuItem value={item.type} key={item.type}>{item.name}</MenuItem>
                                ))
                            }
                        </Select>
                        {
                            props.error.car_type ?
                                <FormHelperText>
                                    {msg}
                                </FormHelperText> : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        error={props.error.vehicle_identification_no}
                        helperText={
                            props.error.vehicle_identification_no ? msg : ""
                        }
                        required
                        id="vehicle_identification_no"
                        name="vehicle_identification_no"
                        label="Vehicle Registration Number"
                        fullWidth
                        autoComplete="regnum"
                        value={props.stepContent.vehicle_identification_no}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <KeyboardDatePicker
                            autoOk
                            disablePast
                            variant="inline"
                            inputVariant="outlined"
                            label="Vehicle Registration Expiry"
                            format="YYYY/MM/DD"
                            value={props.stepContent.license_expiry_date}
                            InputAdornmentProps={{ position: "start" }}
                            onChange={date => {
                                handleChange(date, "license_expiry_date")
                            }}
                            style={{ width: "100%" }}
                            required
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl className={classes.formControl} required error={props.error.vehicle_registration_year}>
                        <InputLabel id="vehicle-registration-year">Vehicle Registration Year</InputLabel>
                        <Select
                            labelId="vehicle-registration-year"
                            id="vehicle-registration-year"
                            name="vehicle_registration_year"
                            value={props.stepContent.vehicle_registration_year}
                            onChange={handleChange}
                        >
                            {
                                years.map(item => (
                                    <MenuItem value={item} key={item}>{item}</MenuItem>
                                ))
                            }
                        </Select>
                        {
                            props.error.vehicle_registration_year ?
                                <FormHelperText>
                                    {msg}
                                </FormHelperText> : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl className={classes.formControl} required error={props.error.vehicle_year}>
                        <InputLabel id="manufacture-year">Manufacture Year</InputLabel>
                        <Select
                            labelId="manufacture-year-label"
                            id="man-year"
                            name="vehicle_year"
                            value={props.stepContent.vehicle_year}
                            onChange={handleChange}
                        >
                            {
                                years.map(item => (
                                    <MenuItem value={item} key={item}>{item}</MenuItem>
                                ))
                            }
                        </Select>
                        {
                            props.error.vehicle_year ?
                                <FormHelperText>
                                    {msg}
                                </FormHelperText> : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl className={classes.formControl} required error={props.error.vehicle_make}>
                        <InputLabel id="vehicle_make-name">Brand</InputLabel>
                        <Select
                            labelId="vehicle_make-name-label"
                            id="vehicle_make"
                            name="vehicle_make"
                            value={props.stepContent.vehicle_make}
                            onChange={handleChange}
                        >
                            {
                                props.brands.length !== 0 ?
                                    props.brands.map(item => (
                                        <MenuItem value={item} key={item}>{item}</MenuItem>
                                    )) : <MenuItem >Please Select Rider Category</MenuItem>
                            }
                        </Select>
                        {
                            props.error.vehicle_make ?
                                <FormHelperText>
                                    {msg}
                                </FormHelperText> : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl className={classes.formControl} required error={props.error.vehicle_model}>
                        <InputLabel id="vehicle_model-label">Model</InputLabel>
                        <Select
                            labelId="select-vehicle_model-label"
                            id="vehicle_model"
                            name="vehicle_model"
                            value={props.stepContent.vehicle_model}
                            onChange={handleChange}
                        >
                            {
                                props.models.length !== 0 ?
                                    props.models.map(item => (
                                        <MenuItem value={item} key={item}>{item}</MenuItem>
                                    )) : <MenuItem >Please Select Rider Category & Brand</MenuItem>
                            }
                        </Select>
                        {
                            props.error.vehicle_model ?
                                <FormHelperText>
                                    {msg}
                                </FormHelperText> : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item sm={12} xs={12}>
                    <div style={{ textAlign: "center" }}>
                        <h3>License Plate no.</h3>
                    </div>
                </Grid>
                <Grid item sm={4} xs={6}>
                    <FormControl className={classes.formControl} required error={props.error.license_plate_district}>
                        <InputLabel id="manufacture-year">District</InputLabel>
                        <Select
                            labelId="city"
                            id="city"
                            value={props.stepContent.license_plate_district}
                            onChange={handleChange}
                            name="license_plate_district"
                        >
                            {
                                cities.map(item => (
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                ))
                            }
                        </Select>
                        {
                            props.error.license_plate_district ?
                                <FormHelperText>
                                    {msg}
                                </FormHelperText> : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item sm={3} xs={6}>
                    <FormControl className={classes.formControl} required error={props.error.license_plate_series}>
                        <InputLabel id="series">Series</InputLabel>
                        <Select
                            labelId="series"
                            id="series"
                            value={props.stepContent.license_plate_series}
                            onChange={handleChange}
                            name="license_plate_series"
                        >
                            {
                                vehicleSeries.map(item => (
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                ))
                            }
                        </Select>
                        {
                            props.error.license_plate_series ?
                                <FormHelperText>
                                    {msg}
                                </FormHelperText> : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item sm={5} xs={12}>
                    <FormControl className={classes.formControl} required error={props.error.license_plate_no.isEmpty || props.error.license_plate_no.invalid}>
                        <NumberFormat
                            error={props.error.license_plate_no.isEmpty || props.error.license_plate_no.invalid}
                            // name="phone"
                            placeholder="XX-XXXX"
                            style={{
                                marginTop: 16,
                                width: "100%"
                            }}
                            customInput={TextField}
                            format="##-####"
                            value={props.stepContent.license_plate_no}
                            onValueChange={(values) => {
                                handleChange(values.formattedValue, "license_plate_no")
                            }}
                        />
                        {
                            props.error.license_plate_no.isEmpty ?
                                <FormHelperText>
                                    {msg}
                                </FormHelperText> : "" || props.error.license_plate_no.invalid ? <FormHelperText>Invalid phone number</FormHelperText> : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <ImageUploader
                        withIcon={false}
                        withPreview={true}
                        buttonText='Choose image'
                        label="Vehicle Registration"
                        labelStyles={{
                            fontSize: 20,
                        }}
                        singleImage={true}
                        onChange={(e) => props.handleChange(e, "driving_registration_front")}
                        imgExtension={['.jpg', '.jpeg', '.gif', '.png', '.gif']}
                        maxFileSize={16777216}
                    />
                    <p>{props.stepContent.driving_registration_front.file !== undefined ? props.stepContent.driving_registration_front.file.name : ""}</p>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <ImageUploader
                        withIcon={false}
                        withPreview={true}
                        buttonText='Choose image'
                        label="Tax Token"
                        labelStyles={{
                            fontSize: 20,
                        }}
                        singleImage={true}
                        onChange={(e) => props.handleChange(e, "tax_token")}
                        imgExtension={['.jpg', '.jpeg', '.gif', '.png', '.gif']}
                        maxFileSize={16777216}
                    />
                    <p>{props.stepContent.tax_token.file !== undefined ? props.stepContent.tax_token.file.name : ""}</p>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <ImageUploader
                        withIcon={false}
                        withPreview={true}
                        buttonText='Choose image'
                        label="Insurance"
                        labelStyles={{
                            fontSize: 20,
                        }}
                        singleImage={true}
                        onChange={(e) => props.handleChange(e, "insurance")}
                        imgExtension={['.jpg', '.jpeg', '.gif', '.png', '.gif']}
                        maxFileSize={16777216}
                    />
                    <p>{props.stepContent.insurance.file !== undefined ? props.stepContent.insurance.file.name : ""}</p>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <ImageUploader
                        withIcon={false}
                        withPreview={true}
                        buttonText='Choose image'
                        label="Certificate of Fitness"
                        labelStyles={{
                            fontSize: 20,
                        }}
                        singleImage={true}
                        onChange={(e) => props.handleChange(e, "fitness")}
                        imgExtension={['.jpg', '.jpeg', '.gif', '.png', '.gif']}
                        maxFileSize={16777216}
                    />
                    <p>{props.stepContent.fitness.file !== undefined ? props.stepContent.fitness.file.name : ""}</p>
                </Grid>
            </Grid>
        </React.Fragment >
    );
}